import { Button, Center } from '@mantine/core';
import { useTranslation } from 'react-i18next';
import { useNavigate } from 'react-router-dom';

import { IconFigmaArrowLeft } from '@/assets/icons';
import { ErrorCard } from '@/pages/ErrorCard';

export const AppNotFoundPage = () => {
  const { t } = useTranslation();
  const navigate = useNavigate();

  return (
    <Center py={40}>
      <ErrorCard
        badge={t('notFoundPage.badge')}
        title={t('notFoundPage.title')}
        message={t('notFoundPage.message')}
        errorCode="ERR_404_NOT_FOUND"
        actions={
          <Button
            fullWidth
            variant="outline"
            leftSection={<IconFigmaArrowLeft size={18} />}
            onClick={() => navigate('/')}
          >
            {t('errorPage.backHome')}
          </Button>
        }
      />
    </Center>
  );
};
